import { useQuery } from "@apollo/client";
import { loader } from "graphql.macro";
import React from "react";
import HomeLoader from "../components/Loaders/HomeLoader";
import RecipeList from "../components/RecipeList";

const RANDOM_RECIPES = loader("../queries/random.graphql");
const seed = new Date().getTime();

export default function Home() {
	const { loading, error, data } = useQuery(RANDOM_RECIPES, {
		variables: { seed: seed, limit: 12 },
	});

	if (loading) {
		return <div className="section content">
			<HomeLoader />
		</div>;
	}

	if (error) {
		return "Error";
	}

	const recipes = data?.search?.hits?.map((el) => el._source) || [];

	return (
		<div className="section content">
			<h1 className="is-size-3">Recipes</h1>
			<RecipeList recipes={recipes} />
		</div>
	);
}
